/* eslint-disable react/jsx-key */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Col, Row, Space, Switch, Transfer } from 'antd'
import { ProductGrnItems } from 'Store/stock/types'
import { ReloadOutlined, SyncOutlined, WarningOutlined } from '@ant-design/icons'
import { numberWithComma } from 'helpers/format'

type Props = {
  productGrn: ProductGrnItems[]
  amount: number
  uom?: string
  onSetSelectedGrn: (grn_item_ids: number[]) => void
  targetKeys: any[]
}

const GrnTransfer: React.FunctionComponent<Props> = props => {
  const { productGrn, amount = 0, onSetSelectedGrn, targetKeys, uom = '' } = props
  const [selectedKeys, setSelectedKeys] = useState([] as any[])
  const [autoStock, setAutoStock] = useState(true)

  useEffect(() => {
    // default auto grn
    if (autoStock) {
      let count = 0
      const target = [] as any[]
      productGrn &&
        productGrn.forEach(grn => {
          if (count > amount) return
          if (grn.item.amount_system > 0) {
            target.push(grn.item.id)
            count += grn.item.amount_system
          }
        })
      onSetSelectedGrn(target)
    }
  }, [autoStock])

  const setTargetKeys = (target: any[]) => {
    onSetSelectedGrn(target)
  }

  const getData = () => {
    const datasource = [] as {
      key: any
      title: string
      description: string
    }[]
    productGrn &&
      productGrn.forEach(data => {
        datasource.push({
          key: data.item.id,
          title: data.grn_no,
          description: `(คงเหลือ ${numberWithComma(data.item.amount_system)} ${uom || ''})`,
        })
      })
    return datasource
  }

  const countTarget = () => {
    let count = 0
    targetKeys.forEach((target: any) => {
      productGrn &&
        productGrn.forEach(grn => {
          if (target === grn.item.id) {
            count += grn?.item.amount_system
          }
        })
    })
    return count
  }

  const onChange = (nextTargetKeys: any) => {
    setTargetKeys(nextTargetKeys)
  }

  const onSelectChange = (sourceSelectedKeys: any, targetSelectedKeys: any) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys])
  }

  const onScroll = (direction: any, e: any) => {}

  const grnCount = countTarget()

  return (
    <Row gutter={[8, 16]}>
      <Col span={24}>
        <Space direction="vertical">
          <InfoTitle>
            การตัดสินค้าออกจากสต๊อกจำนวน {amount} {uom}
          </InfoTitle>
          <div>
            <Switch checked={autoStock} onChange={setAutoStock} />
            &nbsp;
            <InfoValue>
              {!autoStock
                ? 'ตัดสต๊อกแบบเลือก GRN ด้วยตัวเอง'
                : 'ตัดสต๊อกแบบเลือก GRN อัตโนมัติ โดยเรียงลำดับตามการนำสินค้าเข้าคลัง (First In, First Out)'}
            </InfoValue>
          </div>
        </Space>
      </Col>
      {!autoStock && (
        <Col span={24}>
          <Transfer
            dataSource={getData()}
            titles={[
              'เลือก GRN ที่ต้องการนำสินค้าออก',
              <div>
                GRN ที่ต้องการนำสินค้าออก{' '}
                {amount > 0 &&
                  (grnCount >= amount ? (
                    <Success key={grnCount}>(ครบ)</Success>
                  ) : (
                    <Warning key={grnCount}>(ขาดอีก {amount - grnCount})</Warning>
                  ))}
              </div>,
            ]}
            targetKeys={targetKeys}
            selectedKeys={selectedKeys}
            onChange={onChange}
            onSelectChange={onSelectChange}
            onScroll={onScroll}
            render={item => `${item.title} - ${item.description}`}
            oneWay
            listStyle={{
              width: '100%',
              height: 150,
            }}
            showSearch={false}
            disabled={autoStock}
          />
        </Col>
      )}
      {grnCount < amount && productGrn.length > 0 && (
        <Col>
          <Warning>กรุณาเลือก GRN ให้เท่ากับหรือมากกว่าจำนวนสินค้าที่ต้องการนำออก</Warning>
        </Col>
      )}
    </Row>
  )
}

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`

const InfoValue = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const Warning = styled.span`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
  font-size: 12px;
  color: #cd0707;
`

const Success = styled(Warning)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.success};
`

export default GrnTransfer
